import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { requestPasswordReset, resetPassword } from '../lib/allauth-endpoints';

export function useResetPasswordForm() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const resetKey = searchParams.get('key');

  // Request mode state
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestSent, setRequestSent] = useState(false);

  // Reset mode state
  const [showPassword, setShowPassword] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [resetDone, setResetDone] = useState(false);

  const [error, setError] = useState('');

  const handleRequestReset = async (values: { email: string }) => {
    setError('');
    setRequestLoading(true);
    try {
      await requestPasswordReset(values.email);
      setRequestSent(true);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : t('auth.resetEmailFailed'),
      );
    } finally {
      setRequestLoading(false);
    }
  };

  const handleResetPassword = async (values: { password: string }) => {
    setError('');
    setResetLoading(true);
    try {
      await resetPassword(resetKey!, values.password);
      setResetDone(true);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : t('auth.resetPasswordFailed'),
      );
    } finally {
      setResetLoading(false);
    }
  };

  return {
    resetKey,
    error,
    setError,
    requestLoading,
    requestSent,
    handleRequestReset,
    showPassword,
    setShowPassword,
    resetLoading,
    resetDone,
    handleResetPassword,
  };
}
